(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bellzi-quiz"] && !Shopify.designMode) return;
  try {
    
(() => {
const init = (scope) => {
scope.querySelectorAll('[data-bellzi-quiz]').forEach(root => {
if(root.dataset.ready) return;
root.dataset.ready='true';
const questions=Array.from(root.querySelectorAll('[data-quiz-data]'),el=>JSON.parse(el.getAttribute('data-quiz-data')));
const intro=root.querySelector('.quiz-intro'), stage=root.querySelector('.quiz-stage'), result=root.querySelector('.quiz-result'), title=root.querySelector('[data-quiz-question]'), options=root.querySelector('.quiz-answers');
let answers=[], step=0;
root.querySelector('[data-quiz-total]').textContent=questions.length;root.querySelector('progress').max=questions.length;
function render(){intro.hidden=true;result.hidden=true;stage.hidden=false;root.querySelector('[data-quiz-step]').textContent=step+1;root.querySelector('progress').value=step+1;title.textContent=questions[step].title;options.replaceChildren();questions[step].answers.forEach((answer,index)=>{const b=document.createElement('button');b.type='button';b.className='quiz-answer';b.textContent=answer.label;b.setAttribute('aria-pressed',String(answers[step]===index));b.addEventListener('click',()=>choose(index));options.append(b)});title.focus({preventScroll:true});}
function choose(index){answers[step]=index;if(step<questions.length-1){step++;render();return;}const scores=Array(12).fill(0);answers.forEach((a,i)=>Object.entries(questions[i].answers[a].scores).forEach(([id,value])=>scores[Number(id)]+=value));const top=Math.max(...scores);const tied=scores.map((v,i)=>v===top?i:-1).filter(i=>i>=0);const match=tied.sort((a,b)=>{for(let i=answers.length-1;i>=0;i--){const weights=questions[i].answers[answers[i]].scores;const diff=(weights[b]||0)-(weights[a]||0);if(diff)return diff;}return a-b})[0];stage.hidden=true;result.hidden=false;root.querySelectorAll('[data-match]').forEach(el=>el.hidden=Number(el.dataset.match)!==match);const reasons=root.querySelector('[data-quiz-reasons]');reasons.replaceChildren();answers.map((a,i)=>questions[i].answers[a]).filter(a=>a.scores[match]).sort((a,b)=>b.scores[match]-a.scores[match]).slice(0,2).forEach(a=>{const li=document.createElement('li');li.textContent=a.label;reasons.append(li)});result.querySelector('[data-match="'+match+'"] h3').focus({preventScroll:true});}
root.querySelector('[data-quiz-start]').addEventListener('click',()=>{answers=[];step=0;render()});root.querySelector('.quiz-back').addEventListener('click',()=>{if(step>0){step--;render()}else{stage.hidden=true;intro.hidden=false;root.querySelector('[data-quiz-start]').focus()}});root.querySelector('.quiz-restart').addEventListener('click',()=>{answers=[];step=0;render()});
});};init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
(function(){
  const mobile = window.matchMedia('(max-width: 749px)');
  function initializeFooter(){
    document.querySelectorAll('.footer-disclosure').forEach(function(details){
      const summary = details.querySelector('summary');
      details.open = !mobile.matches;
      summary.tabIndex = mobile.matches ? 0 : -1;
      if (!details.dataset.footerReady) {
        summary.addEventListener('click', function(event){if(!mobile.matches) event.preventDefault();});
        details.dataset.footerReady = 'true';
      }
    });
  }
  initializeFooter();
  mobile.addEventListener('change', initializeFooter);
  document.addEventListener('shopify:section:load', initializeFooter);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["halloween-treat-shop"] && !Shopify.designMode) return;
  try {
    
function initTreatShop(root){
 if(root.dataset.treatReady)return;
 const products=[...root.querySelectorAll('[data-treat-group]')];
 const buttons=[...root.querySelectorAll('[data-treat-filter]')];
 const count=root.querySelector('[data-treat-count]');
 const empty=root.querySelector('[data-treat-empty]');
 const progress=root.querySelector('[data-peek-progress]');
 const announce=root.querySelector('[data-peek-announcement]');
 const motion=root.querySelector('[data-peek-motion]');
 const hero=root.querySelector('[data-peek-hero]');
 const heroButton=root.querySelector('[data-peek-hero-button]');
 const reduceMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
 let paused=reduceMotion.matches;
 function setMotion(){
  root.dataset.motionPaused=String(paused||reduceMotion.matches);
  motion.setAttribute('aria-pressed',String(paused||reduceMotion.matches));
  motion.textContent=reduceMotion.matches?'Reduced motion on':paused?'Resume motion':'Pause motion';
  motion.disabled=reduceMotion.matches;
 }
 function updateProgress(){
  const found=products.filter(item=>item.classList.contains('is-revealed')).length;
  progress.textContent=found===products.length?'The whole boo crew is here!':found+' of '+products.length+' friends found';
 }
 function reveal(item,moveFocus){
  if(item.classList.contains('is-revealed'))return;
  const content=item.querySelector('[data-peek-content]');
  const button=item.querySelector('[data-peek-reveal]');
  content.inert=false;
  content.removeAttribute('aria-hidden');
  item.classList.add('is-revealed');
  button.setAttribute('aria-expanded','true');
  button.tabIndex=-1;
  button.setAttribute('aria-hidden','true');
  announce.textContent='Peekaboo! You found '+item.dataset.peekTitle+'.';
  if(moveFocus)content.querySelector('h3 a')?.focus({preventScroll:true});
  updateProgress();
 }
 function cover(item){
  const content=item.querySelector('[data-peek-content]');
  const button=item.querySelector('[data-peek-reveal]');
  item.classList.remove('is-revealed');
  content.inert=true;
  content.setAttribute('aria-hidden','true');
  button.tabIndex=0;
  button.setAttribute('aria-expanded','false');
  button.removeAttribute('aria-hidden');
 }
 function filter(group){
  let visible=0;
  products.forEach(item=>{const show=group==='all'||item.dataset.treatGroup.split(' ').includes(group);item.hidden=!show;if(show)visible++;});
  buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.treatFilter===group)));
  count.textContent=visible+' little '+(visible===1?'friend':'friends')+' to meet';
  empty.hidden=visible>0;
 }
 products.forEach(item=>{
  const button=item.querySelector('[data-peek-reveal]');
  button.addEventListener('click',()=>reveal(item,true));
  cover(item);
 });
 root.querySelector('[data-peek-all]').addEventListener('click',()=>{products.forEach(item=>reveal(item,false));announce.textContent='All '+products.length+' friends revealed. Happy exploring!';});
 root.querySelector('[data-peek-reset]').addEventListener('click',()=>{products.forEach(cover);updateProgress();announce.textContent='Everyone is hiding again. Tap a ghost to play.';});
 motion.addEventListener('click',()=>{paused=!paused;setMotion();});
 reduceMotion.addEventListener('change',setMotion);
 heroButton?.addEventListener('click',()=>{
  hero.classList.add('is-revealed');
  heroButton.setAttribute('aria-expanded','true');
  heroButton.tabIndex=-1;
  heroButton.setAttribute('aria-hidden','true');
  root.querySelector('.treat-shop__sticker').innerHTML='BOO!<br>YOU FOUND US';
  announce.textContent='Boo! The Halloween crew is here. Keep exploring to reveal the best sellers.';
  root.querySelector('.treat-shop__copy .button')?.focus({preventScroll:true});
 });
 buttons.forEach(button=>button.addEventListener('click',()=>filter(button.dataset.treatFilter)));
 if('IntersectionObserver' in window){
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>entry.target.classList.toggle('is-in-view',entry.isIntersecting)),{rootMargin:'50px'});
  products.forEach(item=>observer.observe(item));
  root.addEventListener('shopify:section:unload',()=>{observer.disconnect();reduceMotion.removeEventListener('change',setMotion);},{once:true});
 }
 setMotion();filter('all');updateProgress();
 root.querySelector('[data-peek-controls]').hidden=false;
 root.dataset.treatReady='true';
 root.classList.add('peek-ready');
}
document.querySelectorAll('[data-treat-shop]').forEach(initTreatShop);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-treat-shop]').forEach(initTreatShop));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
(function(){function setup(){if(!('IntersectionObserver' in window)||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;document.querySelectorAll('.collection-directory:not([data-motion-ready])').forEach(function(root){root.dataset.motionReady='true';var observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){if(entry.isIntersecting){entry.target.classList.add('is-arriving');observer.unobserve(entry.target);}});},{threshold:.12});root.querySelectorAll('.directory-card').forEach(function(card){observer.observe(card);});});}setup();document.addEventListener('shopify:section:load',setup);})();

  } catch(e) { console.error(e); }
})();
})();
